import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ivory px-6">
          <div className="text-center max-w-md">
            <p className="font-serif text-3xl text-ink mb-4">MIORA</p>
            <p className="text-ink/60 text-sm mb-6">Une erreur est survenue — rechargez la page.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="btn btn-ink"
            >
              Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
